export enum Command {
    OPEN_TASK_LIST = 'teamscall:openTaskList',
    CREATE_TASK = 'teamscall:createTask',
}
